import { z } from 'zod';

import { AccessControlData } from 'api/useAccessControl/useAccessControl';

export const accessControlDataSchema: z.ZodSchema<AccessControlData> = z.object({
  isVmbiSubscribedOnly: z.boolean(),
});
